import React from "react"
import Button from "components/shared/button/text-button"
import TalkWeekends from "images/icons/talk_weekend.png"
import ReactHtmlParser from "react-html-parser"

export const HorizontalPlanDetails = ({
  benefits,
  data,
  pageToShowEntertainment,
  onSelectPlan,
  id
}) => (
  <div className="plan-block hplan--details">
    <div className="hplan--details-tagline">{data.tagline}</div>
    <ul>
      {Object.keys(benefits).map(benefitID => (
        <li className={data.noBullet ? "noBullet" : "bullet"} key={benefitID}>
          {"Talk Weekends" === benefits[benefitID].mainText && (
            <div className="talkWeekends">
              <img src={TalkWeekends} alt="" />
              {ReactHtmlParser(benefits[benefitID].mainText)}
            </div>
          )}
          {"Talk Weekends" !== benefits[benefitID].mainText && (
            <>{ReactHtmlParser(benefits[benefitID].mainText)}</>
          )}
        </li>
      ))}
    </ul>
    <div className="hplan--horizontal-button">
      <Button
        text="Select"
        onClick={() => {
          if (
            pageToShowEntertainment === "new" &&
            !("ENTERTAINMENT_PROVIDERS" in benefits) &&
            !("SIMO_ENTERTAINMENT_PROVIDERS" in benefits)
          ) {
            onSelectPlan(id, true)
          } else {
            onSelectPlan(id)
          }
        }}
      />
    </div>
  </div>
)

export default HorizontalPlanDetails
